import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICreateRetailerDto, ICreateUserDto, IRetailerDto, ITopUpTransactionDto, IUserDto } from 'src/app/models/backend';
import { ReceiverType } from 'src/app/models/enums/receiverType';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RetailerHomeService {
  id: any;
  cartItems:any

  constructor(private http: HttpClient) {
  }

  readonly urlAuth = environment.apiUrl+'Auth/';
  readonly urlTopUp = environment.apiUrl+'TopUpTransactions/';
  readonly urlReciever = environment.apiUrl+'Recievers/';
  readonly urlOrder = environment.apiUrl+'Orders/';
  readonly urlOrderItems = environment.apiUrl+'OrderItems/';

  // readonly urlAuth = environment.apiUrl+'Auth/'
  // readonly urlTopUp = environment.apiUrl+'TopUpTransactions/';
  // readonly urlReciever = environment.apiUrl+'Recievers/';
  //  readonly urlOrder = environment.apiUrl+'Orders/';

  Token = localStorage.getItem("Token")
  headers = new HttpHeaders()
    .set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', `Bearer ${this.Token}`);

  RegisterWhileTopUp(CreateProductDto: IUserDto) {
    return this.http.post<ICreateUserDto>(this.urlAuth + 'RegisterWhileTopUp', 
    CreateProductDto, { headers: this.headers })
  }

  GetTopUpTransactionsByCustomerId(customerId:any)
  {
    console.log(customerId)
    return this.http.post(`${this.urlTopUp}GetTopUpTransactionsByCustomerId?customerId=${customerId}`,null, { headers: this.headers });
  }

  //Reciever
  CreateReciever(CreateDto: any) {
    return this.http.post(this.urlReciever + 'CreateReciever', CreateDto, { headers: this.headers })
  }
  UpdateReciever(CreateDto: any) {
    return this.http.post(this.urlReciever + 'UpdateReciever', CreateDto, { headers: this.headers })
  }
  GetRecieversByCustomer(CreateDto: any,) {
    return this.http.get(`${this.urlReciever}GetRecieversByCustomer/${CreateDto}?RecieverType=${ReceiverType.PridProduct}`, { headers: this.headers })
  }
  PlaceOrder(CreateDto:any){
    return this.http.post(this.urlOrder + 'PlaceOrder', CreateDto, { headers: this.headers })
  }
  ReProcessOrderItems(CreateDto:any){
    return this.http.post(this.urlOrder + 'ReProcessOrderItems', CreateDto, { headers: this.headers })
  }
  CreateNewTopUpItemByRefNum(referNo,amount){
    return this.http.post(this.urlOrder + `CreateNewTopUpItemByRefNum?pridRefNum=${referNo}&amount=${amount}`,null, { headers: this.headers })
  }
  PrintRecipt(ordernumber:any){
    return this.http.post(this.urlOrder + `PrintOrderRecipt?orderNumber=${ordernumber}`,null, { headers: this.headers })
  }
  PrintCustomerDeliveryReportBulk(payLoad:any){
    return this.http.post(this.urlOrder+'PrintCustomerDeliveryReciptBulk',payLoad,{headers:this.headers});
  }
  DeleteFromHistory(id){
     return this.http.post(this.urlOrderItems + `DeleteFromHistory?prifReferenceNum=${id}`,null, { headers: this.headers })
  }
}
